<nav class="cabecera">
    <h5>{{ title }}</h5>
    <a data-target="slide-out" class="sidenav-trigger"><i class="fa fa-bars"></i></a>
</nav>
<div class="container">
    <div class="row">
        <div class="col s12">
            <div *ngFor="let galpon of galpones;" class="card horizontal" (click)="goToLote(galpon.idGalpon)">
                <div class="col s3">
                    <p class="icon-grande">
                        <i class="fa fa-building"></i>
                    </p>
                </div>
                <div class="col s9">
                    <p>Galpón<br>
                        <strong>#{{ galpon.Galpon }}</strong><br>
                        Fecha de Creación<br>
                        {{ galpon.fecha_creacion | date : 'yyyy-MM-dd hh:mmm' }}
                    </p>
                </div>
            </div>
            <div *ngIf="galpones.length == 0">
                <p>&nbsp;</p>
                <p class="text-center">No se encontraron galpones</p>
            </div>
        </div>
    </div>
</div>
<div id="modalSincronizacionServidorLocal" class="modal">
    <div class="modal-content">
        <h4>Sincronización <i class="fa fa-times-circle" style="color: red;" *ngIf="resource.nacimientosState == null || resource.semanasState == null"></i>
            <i class="fa fa-spinner fa-spin" *ngIf="(!resource.nacimientosState || !resource.semanasState)
            && (resource.semanasState != null && resource.nacimientosState != null)"></i>
            <i class="fa fa-check-circle" style="color: green;" *ngIf="resource.nacimientosState && resource.semanasState"></i>
        </h4>
        <hr>
        <div>
            <h4 style="display:flex; flex-direction: row; justify-content: space-between">Galpones 
                <i class="fa fa-times-circle" style="color: red;" *ngIf="resource.galponesState == null"></i>
                <i class="fa fa-spinner fa-spin" *ngIf="!resource.galponesState && resource.galponesState != null"></i>
                <i class="fa fa-check-circle" style="color: green;" *ngIf="resource.galponesState"></i>
            </h4>
            <h4 style="display:flex; flex-direction: row; justify-content: space-between">Lotes 
                <i class="fa fa-times-circle" style="color: red;" *ngIf="resource.lotesState == null"></i>
                <i class="fa fa-spinner fa-spin" *ngIf="!resource.lotesState && resource.lotesState != null"></i>
                <i class="fa fa-check-circle" style="color: green;" *ngIf="resource.lotesState"></i>
            </h4>
            <h4 style="display:flex; flex-direction: row; justify-content: space-between" *ngIf="user.TipoPesaje != 2">Corrales 
                <i class="fa fa-times-circle" style="color: red;" *ngIf="resource.corralesState == null"></i>
                <i class="fa fa-spinner fa-spin" *ngIf="!resource.corralesState && resource.corralesState != null"></i>
                <i class="fa fa-check-circle" style="color: green;" *ngIf="resource.corralesState"></i>
            </h4>
            <h4 style="display:flex; flex-direction: row; justify-content: space-between">Semanas 
                <i class="fa fa-times-circle" style="color: red;" *ngIf="resource.semanasState == null"></i>
                <i class="fa fa-spinner fa-spin" *ngIf="!resource.semanasState && resource.semanasState != null"></i>
                <i class="fa fa-check-circle" style="color: green;" *ngIf="resource.semanasState"></i>
            </h4>
            <h4 style="display:flex; flex-direction: row; justify-content: space-between" *ngIf="user.TipoPesaje == 2">Nacimientos 
                <i class="fa fa-times-circle" style="color: red;" *ngIf="resource.nacimientosState == null"></i>
                <i class="fa fa-spinner fa-spin" *ngIf="!resource.nacimientosState && resource.nacimientosState != null"></i>
                <i class="fa fa-check-circle" style="color: green;" *ngIf="resource.nacimientosState"></i>
            </h4>
            <h4 style="display:flex; flex-direction: row; justify-content: space-between" *ngIf="user.TipoPesaje != 2">Standares 
                <i class="fa fa-times-circle" style="color: red;" *ngIf="resource.stdGranjaState == null"></i>
                <i class="fa fa-spinner fa-spin" *ngIf="!resource.stdGranjaState && resource.stdGranjaState != null"></i>
                <i class="fa fa-check-circle" style="color: green;" *ngIf="resource.stdGranjaState"></i>
            </h4>
            <h4 style="display:flex; flex-direction: row; justify-content: space-between" *ngIf="user.TipoPesaje == 2">Standares 
                <i class="fa fa-times-circle" style="color: red;" *ngIf="resource.stdPlantaState == null"></i>
                <i class="fa fa-spinner fa-spin" *ngIf="!resource.stdPlantaState && resource.stdPlantaState != null"></i>
                <i class="fa fa-check-circle" style="color: green;" *ngIf="resource.stdPlantaState"></i>
            </h4>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: center;">
            <a class="btn disabled"
            *ngIf="!resource.nacimientosState || !resource.semanasState">Cerrar</a>
            <a class="btn-flat" (click)="close()"
            *ngIf="resource.nacimientosState && resource.semanasState">Cerrar</a>
        </div>
    </div>
</div>
